import React from "react";
import PropTypes from "prop-types";
import { StyledIcon } from "./style";

export const ArrowDirections = [
  "right",
  "right-down",
  "down",
  "left-down",
  "left",
  "left-up",
  "up",
  "right-up",
];

const ArrowIcon = ({ fill = "white", ...restProps }) => {
  return (
    <StyledIcon
      width="100%"
      height="100%"
      viewBox="0 0 17 12"
      fill={fill}
      {...restProps}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.824 0.944824L16.0482 6.16909L10.824 11.3934L9.97544 10.5448L13.7512 6.76909H0.199707V5.56909H13.7512L9.97544 1.79335L10.824 0.944824Z"
        className="fill"
      />
    </StyledIcon>
  );
};

export default ArrowIcon;

ArrowIcon.propTypes = {
  direction: PropTypes.oneOf(ArrowDirections),
  fill: PropTypes.string,
};
